import { makeStyles } from '@material-ui/core/styles';
import { calculateHeight, calculateWidth } from '../../utils/dimension-helper';

export const newStyles = makeStyles((theme) => ({
  iconShoppingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    width: '48px',
    height: '48px',
    borderRadius: '8px',
    marginRight: theme.spacing(2),
  },
  iconShopping: {
    fontSize: 24,
    color: theme.palette.common.white,
  },
  redformlabel: {
    color: theme.palette.error.main,
  },
  helperText: {
    color: theme.palette.error.main,
  },
  margintopuserdiv: {
    backgroundColor: theme.palette.background.default,
    borderRadius: '8px',
    boxShadow: `8px 16px 40px ${theme.palette.fill.secondary}`,
    margin: (props:any)=> {
      const errorHeight = props?.errorHeight?.current?.clientHeight
      const topMargin = errorHeight ? errorHeight < 100 ? 80 : 10 : 80
      return(`${topMargin}px 0px 80px 0px`)
    },
  },
  loginTitleEm: {
    fontWeight: 'bold',
    color: theme.palette.background.default,
  },
  loginTitleCCM: {
    color: theme.palette.background.default,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    padding:(props:any)=>{
      const errorHeight = props?.errorHeight?.current?.clientHeight;
      const topPadding = errorHeight ? errorHeight > 79 ? 10 : 90 - errorHeight : 79
      return `${topPadding}px 68px 79px 68px`
    } ,
  },
  toolbarButtons: {
    marginLeft: 'auto',
  },
  menuicon: {
    fontSize: calculateWidth(39).stringValue,
    backgroundColor: 'transparent',
    color: 'white',
  },
  menucontainer: {
    marginTop: calculateHeight(14).stringValue,
    marginLeft: calculateWidth(18).stringValue,
  },
}));
